// eslint-disable-next-line import/no-cycle
import axios from '@/core/plugins/axios';

const baseUrl = import.meta.env.VITE_API_TV;
const headers = {
  'Content-Type': 'application/json; Charset=UTF-8',
};
const multiPartHeaders = {
  'Content-Type': 'multipart/form-data',
};
const FOLDER_IMAGE_URL = '/s3/video/folder';
const FOLDER_IMAGE_PARTNER_URL = '/api/v1/folders/{folderLanguageId}/covers/{coverType}';

export default {
  getFolders(options = null) {
    let params = null;

    if (options) {
      const {
        activity = '',
        language = '',
        license = '',
        offset = 0,
        limit = 10,
        keyword = '',
        country = '',
        type = '',
        sort = '',
      } = options;

      params = {
        offset,
        fetchLimit: limit,
        licenseId: license,
        languageId: language,
        isActive: activity,
        search: keyword,
      };
      if (country !== '') params.countryId = country;

      if (sort) {
        params.sortColumns = type;
        params.sortColumnOrders = sort;
      }
    }

    return axios({
      method: 'get',
      url: `${baseUrl}/folders`,
      headers,
      params,
    });
  },
  getFoldersList() {
    return axios({
      method: 'get',
      url: `${baseUrl}/folders`,
      headers,
    });
  },
  // Check if we can depricate this
  getSlimFolders() {
    return axios({
      method: 'get',
      url: `${baseUrl}/folders/slim`,
      headers,
    });
  },
  getFolder(id) {
    const params = {
      folderId: id,
    };

    return axios({
      method: 'get',
      url: `${baseUrl}/folder`,
      headers,
      params,
    });
  },
  createFolder(data) {
    return axios({
      method: 'post',
      url: baseUrl + '/folder',
      headers,
      data,
    });
  },
  updateFolder(data) {
    return axios({
      method: 'put',
      url: baseUrl + '/folder',
      headers,
      data,
    });
  },
  deleteFolderLanguage(folderId, folderLanguageId) {
    return axios({
      method: 'delete',
      url: `${baseUrl}/folder/language?folderId=${folderId}&folderLanguageId=${folderLanguageId}`,
      headers,
    });
  },
  deleteFolderVideo(folderId, videoId) {
    return axios({
      method: 'delete',
      url: `${baseUrl}/folder/video?folderId=${folderId}&videoId=${videoId}`,
      headers,
    });
  },
  deleteIncomingFolderVideo(videoId) {
    return axios({
      method: 'delete',
      url: `${baseUrl}/videos/incoming/delete?videoIncomingId=${videoId}`,
      headers,
    });
  },
  deleteFolder(id) {
    const params = {
      folderId: id,
    };

    return axios({
      method: 'delete',
      url: `${baseUrl}/folder`,
      headers,
      params,
    });
  },
  updateFolderStatus(id) {
    const params = {
      folderId: id,
    };

    return axios({
      method: 'put',
      url: `${baseUrl}/folder/status`,
      headers,
      params,
    });
  },
  getFoldersOrder() {
    return axios({
      method: 'get',
      url: `${baseUrl}/folders/order`,
      headers,
    });
  },
  getFilteredFoldersOrder(options = null) {
    let params = null;

    if (options) {
      const {
        country = '',
        language = '',
        thematic = '',
      } = options;

      params = {
        countryId: country,
        languageId: language,
        thematicId: thematic,
      };
    }
    return axios({
      method: 'get',
      url: `${baseUrl}/folders/order`,
      headers,
      params
    });
  },
  updateFoldersOrder(order) {
    const data = {
      reorders: order, // DEV NOTE: will be modified to send only the array itself
    };

    return axios({
      method: 'put',
      url: `${baseUrl}/folders/reorder`,
      headers,
      data,
    });
  },

  createFolderImage(data) {
    return axios({
      method: 'post',
      url: `${baseUrl}${FOLDER_IMAGE_URL}`,
      multiPartHeaders,
      data
    });
  },
  createFolderPartnerImage({ ...data }) {
    return axios({
      method: 'post',
      url: `${baseUrl}/folders/${data.langId}/covers/${data.coverType}`,
      multiPartHeaders,
      data: data.img
    });
  },
  updateFolderImage(data, folderId, language) {
    return axios({
      method: 'put',
      url: `${baseUrl}${FOLDER_IMAGE_URL}`,
      multiPartHeaders,
      data,
      params: {
        folderId,
        language
      }
    });
  }
};
